import { Methods, Response } from 'types/request.ts'
import { getAxiosRequestConfigBoltBackend, newRequest } from 'utils/request.ts'
import { log } from 'utils/logging.ts'
import { Flow } from 'types/logging.ts'
import { CreateMysterySwitchCaseRequestBody } from '@boltenergy-be/shared'

export const postMysterySwitchCase = async (body: CreateMysterySwitchCaseRequestBody): Promise<Response> => {
  try {
    const res = await newRequest(getAxiosRequestConfigBoltBackend(Methods.POST, '/resources/cases/mystery-switch', body))

    if (!res.success) {
      log({
        error: res?.message || 'unknown error with postMysterySwitchCase',
        identifier: `[${Flow.CASES}:postMysterySwitchCase${res?.errorCode ? `:${res.errorCode}` : ''}]`,
        errorCode: res?.errorCode
      })
    }

    return res
  } catch (error) {
    log({
      error: error instanceof Error ? error : 'Unknown error in postMysterySwitchCase',
      identifier: `[${Flow.CASES}:CATCH:postMysterySwitchCase]`
    })
    return { success: false }
  }
}
